import dayjs from 'dayjs';
import type { FeedChange } from './ActivityFeed';

const ISO_RE = /^\d{4}-\d{2}-\d{2}T/;

export function fmtValue(v: unknown): string {
  if (v == null || v === '') return '—';
  let s = typeof v === 'object' ? JSON.stringify(v) : String(v);
  if (ISO_RE.test(s)) s = dayjs(s).format('DD.MM.YYYY HH:mm');
  if (s.length > 120) s = `${s.slice(0, 120)}…`;
  return s;
}

export function extractChanges(
  payload: Record<string, unknown>,
  labels: Record<string, string>,
): FeedChange[] | undefined {
  const raw = payload?.changes;
  if (!Array.isArray(raw)) return undefined;
  const changes = raw
    .filter(
      (c): c is Record<string, unknown> =>
        c != null &&
        typeof c === 'object' &&
        typeof (c as Record<string, unknown>).field === 'string',
    )
    .map((c) => ({
      label: labels[c.field as string] ?? (c.field as string),
      from: fmtValue(c.from),
      to: fmtValue(c.to),
    }));
  return changes.length > 0 ? changes : undefined;
}

export function fieldNameList(
  payload: Record<string, unknown>,
  labels: Record<string, string>,
): string {
  const fields = payload?.fields;
  if (!Array.isArray(fields)) return 'fields';
  return (
    fields.map((f) => labels[f as string] ?? String(f)).join(', ') || 'fields'
  );
}
